import type { FacetParams } from '@apptus/esales-api';
import type { Filter } from '@server/utils/parseLoop/types';

function mapNgFilterToElvateFacet(filter: Filter): [string, any][] {
    if (filter.type === 'range') {
        const [min, max] = filter.values ?? [];
        if (typeof min !== 'number' || typeof max !== 'number') return [];
        return [
            [filter.attribute + '.min', min],
            [filter.attribute + '.max', max],
        ];
    }
    if (filter.type === 'checkbox') {
        return [[filter.attribute, filter.values]];
    }
    return [];
}

export default function mapNgFilters(filters: Filter[]): FacetParams {
    return Object.fromEntries(filters.map(mapNgFilterToElvateFacet).flat());
}
